import React, { useEffect, useState } from "react";
import { Col, Row, Card, Table, Badge } from 'react-bootstrap';
import { Calendar } from "primereact/calendar";
import moment from 'moment';
import axios from 'axios';
import config from "../../config";
import { useAuth } from "../../context/AuthContext";
import '../../assets/css/tasksheet.css'
import { Link } from "react-router-dom";
import { VscFlame } from "react-icons/vsc";
import { PiFlagBannerFill } from "react-icons/pi";
import { Button } from 'primereact/button';
import { getSocket } from "../../context/socket";

const New_Dailytask_Employee = () => {
    const { accessToken, userId } = useAuth();
    const [selectedMonth, setSelectedMonth] = useState(new Date());
    const [daysInMonth, setDaysInMonth] = useState([]);
    const [tasksheets, setTasksheets] = useState([]);
    const isWeekend = (day) => day.day() === 0 || day.day() === 6;
    const socket = getSocket();

    useEffect(() => {
        const startOfMonth = moment(selectedMonth).startOf('month');
        const endOfMonth = moment(selectedMonth).endOf('month');

        // ✅ Generate all days for the calendar header
        const days = [];
        for (let day = startOfMonth.clone(); day.isSameOrBefore(endOfMonth); day.add(1, 'day')) {
            days.push(day.clone());
        }
        setDaysInMonth(days);

        // ✅ Emit socket request for tasksheet data
        socket.emit("fetchUserTaskSheetByDate", {
            user_id: userId,
            start_date: startOfMonth.format("YYYY-MM-DD"),
            end_date: endOfMonth.format("YYYY-MM-DD")
        });

        // ✅ Handle socket response
        const handleFetchedData = ({ success, data }) => {
            if (!success || !data) return;

            if (success) {
                setTasksheets(data);  // ✅ keep the original shape
            }
        };

        socket.on("userTaskSheetFetched", handleFetchedData);

        return () => {
            socket.off("userTaskSheetFetched", handleFetchedData);
        };
    }, [selectedMonth, userId, socket]);


    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        const options = { day: 'numeric', month: 'short' }; // e.g., "7 Apr"
        return date.toLocaleDateString('en-US', options);
    };

    const getDueDateClass = (dueDate) => {
        if (!dueDate) return "";

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const due = new Date(dueDate);
        due.setHours(0, 0, 0, 0);

        const diffDays = (due - today) / (1000 * 60 * 60 * 24);

        if (diffDays < 0) {
            return "bg-danger"; // Passed
        } else if (diffDays === 0) {
            return "bg-danger"; // Today
        } else if (diffDays === 1) {
            return "bg-warning"; // Tomorrow
        } else {
            return "bg-success"; // Future
        }
    };

    /*--------show hide task sheet------*/
    const [expandedCards, setExpandedCards] = useState({});

    const toggleContent = (cardId) => {
        setExpandedCards(prev => ({
            ...prev,
            [cardId]: !prev[cardId]
        }));
    };

    return (
        <Row className='body_content'>
            <Col lg={12}>
                <Card className="shadow-0 p-0">
                    <Card.Header className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-4 gap-lg-0">
                        <h6 className="mb-0 me-2">Daily Task Sheet</h6>
                        <div>
                            <label className="me-2">Filter by Month</label>
                            <Calendar
                                value={selectedMonth}
                                onChange={(e) => setSelectedMonth(e.value)}
                                view="month"
                                dateFormat="MM yy"
                                placeholder="Choose a month"
                                showButtonBar
                                style={{ width: '170px' }}
                            />
                            <Link to={'/Graphe/dashboard/single_employee_report'}>
                                <Button
                                    label="Monthly Report"
                                    icon="pi pi-file"
                                    severity="danger"
                                    outlined
                                    className="ms-0 ms-lg-2 mt-4 mt-lg-0"

                                />
                            </Link>
                        </div>

                    </Card.Header>
                    <Card.Body>
                        <div className="table-responsive dailytaskemp">
                            <Table className="employee-table">
                                <thead>
                                    <tr className="table-primary">
                                        {daysInMonth.map((day, index) => (
                                            <th key={index} className={isWeekend(day) ? 'table-danger' : ''}>
                                                {day.format('ddd, MMM D')}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        {daysInMonth.map((day, index) => {
                                            const dateKey = day.format('YYYY-MM-DD');
                                            const cardsForDay = tasksheets[dateKey] || [];

                                            return (
                                                <td key={index} className={isWeekend(day) ? 'table-danger' : ''}>
                                                    <ul>
                                                        {cardsForDay.map((entry, cardIndex) => (
                                                            <li key={`card-${entry.card.card_id}-${cardIndex}`} className="mb-3 position-relative">
                                                                <p className="mb-0">
                                                                    <span>Brand:</span> {entry.card?.list?.board?.brand?.brand_name || 'No brand'}
                                                                    {entry.card?.priority === 'Urgent' && (
                                                                        <small className="misses_image2">
                                                                            <PiFlagBannerFill className="ms-3" />
                                                                        </small>
                                                                    )}
                                                                </p>
                                                                {entry.card?.missed_deadline && (
                                                                    <div className="misses_image">
                                                                        <VscFlame />
                                                                    </div>
                                                                )}
                                                                <p className="mb-0">
                                                                    <span>Project:</span> {entry.card?.list?.board?.project?.project_name || 'No project'}
                                                                </p>

                                                                <p className="mb-0">
                                                                    <span>Task:</span> {entry.card?.title || 'No task'}
                                                                </p>
                                                                <p className="mb-0 d-flex justify-content-start align-items-center">
                                                                        {/* <b style={{ fontSize: '12px' }}>In list: </b> */}
                                                                    <span
                                                                        style={{
                                                                            fontSize: '12px',
                                                                            backgroundColor: entry.card?.list?.color_code || '#ccc',
                                                                            color: '#fff',
                                                                            padding: '0px 5px',
                                                                            borderRadius: '4px',
                                                                            marginRight: '5px',
                                                                            display: 'inline-block'
                                                                        }}
                                                                    >
                                                                        {entry.card?.list?.name}
                                                                    </span>
                                                                    <span className={`text-white rounded ${getDueDateClass(entry.card?.due_date)}`} style={{ fontSize: '11px', padding: '2px 5px' }}>
                                                                        <i className="pi pi-calendar" style={{ fontSize: '11px' }}></i>
                                                                        {" "}{formatDate(entry.card?.createdAt)} - {formatDate(entry.card?.due_date)}
                                                                    </span>
                                                                    <span
                                                                        className="text-black ms-2 bg-secondary px-1"
                                                                        onClick={() => toggleContent(entry.card?.card_id)}
                                                                        style={{ cursor: 'pointer', borderRadius: '4px' }}
                                                                    >
                                                                        {expandedCards[entry.card?.card_id] ? 'Less...' : 'More...'}
                                                                    </span>
                                                                </p>
                                                                <div className={`shmorTask transition-div ${expandedCards[entry.card?.card_id] ? 'show' : 'hide'}`}>
                                                                    <p className="mb-0 mt-2 border-bottom" style={{ width:'fit-content' }}>
                                                                        <b>Work Done:</b>
                                                                    </p>
                                                                    {entry.taskSheets.map((sheet, i) => (
                                                                        <ul style={{ listStyle: 'disc' }} cl>
                                                                            <li key={`ts-${sheet.tasksheet_id}-${i}`} className="pb-1 mb-1" style={{ borderBottom: '1px dashed #c2c2c2' }}>
                                                                                <div className="mb-0 text-muted d-flex" style={{ fontSize: '13px', lineHeight: '1.2' }}>
                                                                                    {/* <span>Work :</span>  */}
                                                                                    <span className="ms-1">{sheet.note || 'No note'}</span>
                                                                                </div>
                                                                                <div className="d-flex justify-content-start align-items-center">
                                                                                    <p className="mb-0">
                                                                                        {/* <span>Task Stage:</span> */}
                                                                                        <Badge pill className="ms-2">
                                                                                            {sheet.status || 'No status'}
                                                                                        </Badge>
                                                                                    </p>
                                                                                    {sheet.missed_deadline && (
                                                                                        <div className="text-danger ms-3" style={{ fontSize: '16px' }}>
                                                                                            <VscFlame />
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                                {sheet.checklist && (
                                                                                    <p className="mb-0 text-muted">
                                                                                        <span> Subtask Name:</span> <span>{sheet.checklist.name}</span>{' '}
                                                                                        <span style={{ color: sheet.checklist.is_checked ? 'green' : 'red' }}>
                                                                                            {sheet.checklist.is_checked ? '✓' : '✗'}
                                                                                        </span>
                                                                                    </p>
                                                                                )}
                                                                            </li>
                                                                        </ul>
                                                                    ))}
                                                                </div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </td>
                                            );
                                        })}
                                    </tr>
                                </tbody>
                            </Table>

                        </div>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default New_Dailytask_Employee
